@if (isLoading) {
    <app-rings-loader></app-rings-loader>
}
<div class="modal-header">
    <h3 class="dialog-title text-center">{{ title }}</h3>
</div>
<div mat-dialog-content>
    <div class="modal-content">
        <div class="logo-img-container">
            <img src="assets/images/grpLogo.svg" alt="" class="logo-img" />
        </div>
        <app-progress-spinner [show]="isFormLoading"></app-progress-spinner>
        <div class="modal-body">
            <div>
                <div class="form-fields-body">
                    <div class="row">
                        @for (field of fields; track $index) {
                            <div
                                [ngClass]="
                                    field.visible
                                        ? field.columnSpanClass
                                        : ''
                                "
                            >
                                @if (field.type === FormFieldType.Text && field.visible) {
                                    <mat-form-field
                                        [class]="field.cssClass"
                                    >
                                        <mat-label class="field-label"
                                            >{{ field.name | translate }}
                                            @if (field.tooltip) {
                                                <i
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="field.tooltip"
                                                    matTooltipPosition="right"
                                                ></i>
                                            }
                                        </mat-label>
                                        <input
                                            matInput
                                            [(ngModel)]="entity[field.property]"
                                            [required]="field.required"
                                            [placeholder]="field.tooltip"
                                            [readonly]="field.readonly"
                                            [class.cursor-not-allowed]="field.readonly"
                                            (change)="field.onChange($event, field); updateFieldVisibility()"
                                        />
                                        <mat-error
                                            >{{ field.name | translate }}
                                            {{ "is required" | translate }}</mat-error
                                        >
                                    </mat-form-field>
                                }

                                @if (field.type === FormFieldType.TextArea && field.visible) {
                                    <mat-form-field
                                        appearance="outline">
                                        <mat-label class="field-label"
                                            >{{ field.name | translate }}
                                            @if (field.tooltip) {
                                                <i
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="field.tooltip"
                                                    matTooltipPosition="right"
                                                ></i>
                                            }
                                        </mat-label>
                                        <textarea
                                            matInput
                                            [(ngModel)]="entity[field.property]"
                                            [placeholder]="field.tooltip"
                                            [required]="field.required"
                                            [readonly]="field.readonly"
                                            [class.cursor-not-allowed]="field.readonly"
                                            (ngModelChange)="field.onChange($event, field); updateFieldVisibility()"
                                        ></textarea>
                                        <mat-error
                                            >{{ field.name | translate }}
                                            {{ "is required" | translate }}</mat-error
                                        >
                                    </mat-form-field>
                                }

                                @if (
                                        (field.type ===
                                            FormFieldType.SingleSelection ||
                                            field.type ===
                                                FormFieldType.MultipleSelection ||
                                            field.type ===
                                                FormFieldType.HierarchicalSelection) &&
                                        field.visible
                                ) {
                                    <mat-form-field
                                        [class]="field.cssClass"
                                        [class.search-extended]="field.searchComponent"
                                    >
                                        <mat-label class="field-label"
                                            >{{ field.name | translate }}
                                            @if (field.tooltip) {
                                                <i
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="field.tooltip"
                                                    matTooltipPosition="right"
                                                ></i>
                                            }
                                        </mat-label>
                                        <mat-select
                                            (selectionChange)="
                                                field.onChange($event, field); updateFieldVisibility()
                                            "
                                            [placeholder]="field.tooltip"
                                            [(ngModel)]="entity[field.property]"
                                            [required]="field.required"
                                            [disabled]="$safeNavigationMigration(field?.readonly)"
                                            [class.cursor-not-allowed]="field.readonly"
                                            [multiple]="
                                                field.type ===
                                                    FormFieldType.MultipleSelection ||
                                                (field.type ===
                                                    FormFieldType.HierarchicalSelection &&
                                                    field.multiple)
                                            "
                                            [panelClass]="
                                                field.type ===
                                                FormFieldType.HierarchicalSelection
                                                    ? 'hierarchical-select-panel'
                                                    : field.optionTemplate ||
                                                        field.optionTemplateFields
                                                            ?.length
                                                      ? 'multiple-select-panel'
                                                      : ''
                                            "
                                        >
                                            <mat-option>
                                                <ngx-mat-select-search
                                                    [(ngModel)]="
                                                        entity[field.searchProperty]
                                                    "
                                                    placeholderLabel="{{
                                                        'Search' | translate
                                                    }}..."
                                                    (ngModelChange)="
                                                        field.onSearchChange(
                                                            $event,
                                                            field
                                                        )
                                                    "
                                                >
                                                </ngx-mat-select-search>
                                            </mat-option>

                                            @if (
                                                    field.type ===
                                                        FormFieldType.HierarchicalSelection &&
                                                    (
                                                        field.options
                                                        | filter
                                                            : entity[
                                                                  field.searchProperty
                                                              ]
                                                            : field.searchKeys
                                                    ).length === 0
                                            ) {
                                                <mat-option
                                                    disabled
                                                >
                                                    {{ "No options found" | translate }}
                                                </mat-option>
                                            }

                                            @if (field.type === FormFieldType.HierarchicalSelection) {
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        renderTree;
                                                        context: {
                                                            nodes:
                                                                field.options
                                                                | filter
                                                                    : entity[
                                                                          field
                                                                              .searchProperty
                                                                      ]
                                                                    : field.searchKeys,
                                                            level: 0,
                                                        }
                                                    "
                                                ></ng-container>
                                            }

                                            @if (field.type !== FormFieldType.HierarchicalSelection) {
                                                @if (field.groups && field.groups.length > 0) {
                                                    @for (group of field.groups; track $index) {
                                                        <mat-optgroup
                                                            [label]="group.groupName"
                                                        >
                                                            @for (option of group.items | filter : entity[field.searchProperty]; track trackByEntityId($index, option)) {
                                                                <mat-option
                                                                    [value]="option.id"
                                                                >
                                                                    {{
                                                                        option.name | translate
                                                                    }}
                                                                </mat-option>
                                                            }
                                                            @if (
                                                                    (
                                                                        group.items
                                                                        | filter
                                                                            : entity[
                                                                                  field
                                                                                      .searchProperty
                                                                              ]
                                                                    ).length === 0
                                                            ) {
                                                                <mat-option
                                                                    disabled
                                                                >
                                                                    {{
                                                                        "No options found"
                                                                            | translate
                                                                    }}
                                                                </mat-option>
                                                            }
                                                        </mat-optgroup>
                                                    }
                                                } @else {
                                                    @if (
                                                            field.optionTemplate &&
                                                            !field.optionTemplateFields
                                                                ?.length &&
                                                            field.options.length
                                                    ) {
                                                        <mat-option
                                                            disabled
                                                            class="static-option-header"
                                                        >
                                                            <div
                                                                class="select-option header"
                                                                [innerHTML]="
                                                                    field.optionTemplate(
                                                                        field.options[0],
                                                                        true
                                                                    ) | safeHtml
                                                                "
                                                            ></div>
                                                        </mat-option>
                                                    }
                                                    @if (field.optionTemplateFields?.length && field.options.length) {
                                                        <mat-option
                                                            disabled
                                                            class="static-option-header"
                                                        >
                                                            <app-option-row
                                                                [option]="field.options[0]"
                                                                [fields]="
                                                                    field.optionTemplateFields
                                                                "
                                                                [isHeader]="true"
                                                                [labelMap]="
                                                                    field.optionTemplateLabelMap
                                                                "
                                                                [badgeFields]="
                                                                    field.optionTemplateBadgeFields
                                                                "
                                                            >
                                                            </app-option-row>
                                                        </mat-option>
                                                    }

                                                    @for (option of field.options | filter : entity[field.searchProperty] : field.searchKeys; track trackByEntityId($index, option)) {
                                                        <mat-option
                                                            [value]="option.id"
                                                        >
                                                            @if (field.optionTemplate) {
                                                                <div
                                                                    class="select-option"
                                                                    [innerHTML]="
                                                                        field.optionTemplate(
                                                                            option,
                                                                            false
                                                                        ) | safeHtml
                                                                    "
                                                                ></div>
                                                            } @else {
                                                                @if (field.optionTemplateFields?.length) {
                                                                    <app-option-row
                                                                        [option]="option"
                                                                        [fields]="
                                                                            field.optionTemplateFields
                                                                        "
                                                                        [isHeader]="false"
                                                                        [labelMap]="
                                                                            field.optionTemplateLabelMap
                                                                        "
                                                                        [badgeFields]="
                                                                            field.optionTemplateBadgeFields
                                                                        "
                                                                    >
                                                                    </app-option-row>
                                                                } @else {
                                                                    {{
                                                                        option.name | translate
                                                                    }}
                                                                }
                                                            }
                                                        </mat-option>
                                                    }

                                                    @if (
                                                            (
                                                                field.options
                                                                | filter
                                                                    : entity[
                                                                          field
                                                                              .searchProperty
                                                                      ]
                                                                    : field.searchKeys
                                                            ).length === 0
                                                    ) {
                                                        <mat-option
                                                            disabled
                                                        >
                                                            {{ "No options found" | translate }}
                                                        </mat-option>
                                                    }
                                                }
                                            }

                                            @if (field.selectionTemplate) {
                                                <mat-select-trigger>
                                                    <span
                                                        [innerHTML]="
                                                            field.selectionTemplate(field)
                                                                | safeHtml
                                                        "
                                                    ></span>
                                                </mat-select-trigger>
                                            }

                                            <ng-template
                                                #renderTree
                                                let-nodes="nodes"
                                                let-level="level"
                                            >
                                                @for (node of nodes; track trackByEntityId($index, node)) {
                                                    <mat-option
                                                        [value]="node.id"
                                                        [ngClass]="'mat-level-' + level"
                                                    >
                                                        @for (i of [].constructor(level); track $index; let idx = $index) {
                                                            <div
                                                                class="pre-option-line"
                                                                [ngClass]="
                                                                    'pre-option-level-' +
                                                                    idx
                                                                "
                                                            ></div>
                                                        }
                                                        {{ node.name }}
                                                    </mat-option>
                                                    @if (node.children && node.children.length > 0) {
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                renderTree;
                                                                context: {
                                                                    nodes: node.children,
                                                                    level: level + 1,
                                                                }
                                                            "
                                                        ></ng-container>
                                                    }
                                                }
                                            </ng-template>
                                        </mat-select>

                                        @if (
                                                entity[field.property] !== null &&
                                                entity[field.property] !== undefined &&
                                                field.type ===
                                                    FormFieldType.SingleSelection &&
                                                !field?.readonly
                                        ) {
                                            <button
                                                class="selection-close-btn"
                                                mat-icon-button
                                                matSuffix
                                                tabindex="-1"
                                                (click)="
                                                    clearSelect(field);
                                                    $event.stopPropagation()
                                                "
                                                [attr.aria-label]="
                                                    'Clear selection' | translate
                                                "
                                            >
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        }

                                        @if (
                                                field.required &&
                                                (field.type ===
                                                    FormFieldType.MultipleSelection ||
                                                (field.type ===
                                                    FormFieldType.HierarchicalSelection &&
                                                    field.multiple)
                                                    ? !entity[field.property]?.length
                                                    : !entity[field.property])
                                        ) {
                                            <mat-error>
                                                {{ field.name | translate }}
                                                {{ "is required" | translate }}
                                            </mat-error>
                                        }
                                    </mat-form-field>
                                }

                                @if (field.searchComponent && field.visible) {
                                    <div
                                        class="extended-search-icon"
                                    >
                                        <span
                                            class="material-symbols-outlined"
                                            (click)="openSearchDialog(field)"
                                            >search</span
                                        >
                                    </div>
                                }

                                @if (field.type === FormFieldType.Checkbox && field.visible) {
                                    <div
                                        class="padding-y-10">
                                        <mat-checkbox
                                            color="primary"
                                            [(ngModel)]="entity[field.property]"
                                            (change)="field.onChange($event); updateFieldVisibility()"
                                        >
                                            {{ field.name | translate }}
                                        </mat-checkbox>
                                    </div>
                                }

                                @if (field.type === FormFieldType.Radio && field.visible) {
                                    <div
                                        class="padding-y-10"
                                        [class]="field.cssClass"
                                    >
                                        <label class="field-label block mb-2"
                                            >{{ field.name | translate }}
                                            @if (field.tooltip) {
                                                <i
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="field.tooltip"
                                                    matTooltipPosition="right"
                                                ></i>
                                            }
                                        </label>
                                        <mat-radio-group
                                            [(ngModel)]="entity[field.property]"
                                        >
                                            @for (option of field.options; track trackByEntityId($index, option)) {
                                                <mat-radio-button
                                                    [value]="option.id"
                                                    (change)="field.onChange(option.id); updateFieldVisibility()"
                                                >
                                                    {{ option.name | translate }}
                                                </mat-radio-button>
                                            }
                                        </mat-radio-group>
                                    </div>
                                }

                                @if (field.type === FormFieldType.Label && field.visible) {
                                    <div
                                        class="padding-y-10"
                                        [class]="field.cssClass"
                                        (click)="field.onClick(entity[field.property])"
                                    >
                                        @if (field.iconClass) {
                                            <span>
                                                <i
                                                    [ngClass]="field.iconClass"
                                                    class="icon"
                                                ></i>
                                            </span>
                                        }
                                        <mat-label class="mr-3 field-label"
                                            >{{ field.name | translate }}
                                            @if (field.tooltip) {
                                                <i
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="field.tooltip"
                                                    matTooltipPosition="right"
                                                ></i>
                                            }
                                        </mat-label>
                                    </div>
                                }

                                @if (field.type === FormFieldType.Toggle && field.visible) {
                                    <div
                                        class="padding-y-10"
                                        [class]="field.cssClass"
                                    >
                                        <mat-label class="mr-3 field-label"
                                            >{{ field.name | translate }}
                                            @if (field.tooltip) {
                                                <i
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="field.tooltip"
                                                    matTooltipPosition="right"
                                                ></i>
                                            }
                                        </mat-label>
                                        <mat-slide-toggle
                                            color="primary"
                                            [disabled]="field.readonly"
                                            (change)="field.onChange($event, field); updateFieldVisibility()"
                                            [(ngModel)]="entity[field.property]"
                                        ></mat-slide-toggle>
                                    </div>
                                }

                                @if (field.type === FormFieldType.Button && field.visible) {
                                    <div
                                        class="padding-y-10"
                                        [class]="field.cssClass"
                                    >
                                        <button
                                            mat-button
                                            color="primary"
                                            (click)="
                                                field.onClick(entity[field.property])
                                            "
                                            class="button date-name"
                                            [disabled]="field.readonly"
                                        >
                                            @if (field.iconClass) {
                                                <span>
                                                    <i
                                                        [ngClass]="field.iconClass"
                                                        class="icon"
                                                    ></i>
                                                </span>
                                            }
                                            {{ field.name | translate }}
                                        </button>
                                    </div>
                                }

                                @if (field.type === FormFieldType.Number && field.visible) {
                                    <mat-form-field>
                                        <mat-label class="field-label">
                                            {{ field.name | translate }}
                                            {{ field.additionalLabelText }}
                                            @if (field.tooltip) {
                                                <i
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="field.tooltip"
                                                    matTooltipPosition="right"
                                                ></i>
                                            }
                                        </mat-label>
                                        <input
                                            matInput
                                            type="number"
                                            [required]="field.required"
                                            [readonly]="field.readonly"
                                            (input)="field.onChange($event, field); updateFieldVisibility()"
                                            (blur)="onFieldBlur(field)"
                                            [(ngModel)]="entity[field.property]"
                                            [min]="field.numericMin"
                                            [max]="field.numericMax"
                                            [placeholder]="field.tooltip"
                                            (keypress)="
                                                onKeyPressValidateInput(
                                                    $event,
                                                    field.displayFormat,
                                                    field.numericMin
                                                )
                                            "
                                        />
                                        <!-- DASH-2676: show the field's custom validation message when present,
                                             otherwise fall back to the generic required message. -->
                                        @if (getFieldError(field); as fieldError) {
                                            <mat-error>{{
                                                fieldError | translate
                                            }}</mat-error>
                                        }
                                        @if (!getFieldError(field)) {
                                            <mat-error
                                                >{{ field.name | translate }}
                                                {{ "is required" | translate }}</mat-error
                                            >
                                        }
                                    </mat-form-field>
                                }

                                @if (field.type === FormFieldType.Time && field.visible) {
                                    <mat-form-field>
                                        <mat-label class="field-label">
                                            {{ field.name | translate }}
                                            @if (field.tooltip) {
                                                <i
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="field.tooltip"
                                                    matTooltipPosition="right"
                                                ></i>
                                            }
                                        </mat-label>
                                        <input
                                            matInput
                                            [required]="field.required"
                                            [disabled]="field.readonly"
                                            class="time-input"
                                            [(ngModel)]="entity[field.property]"
                                            [placeholder]="field.tooltip"
                                            (ngModelChange)="
                                                onTimeChange($event, field)
                                            "
                                            [ngxMatTimepicker]="timePicker"
                                            [format]="'' | hour12Flag"
                                            [readonly]="field.readonly"
                                        />
                                        <ngx-mat-timepicker-toggle
                                            matSuffix
                                            [for]="timePicker"
                                        ></ngx-mat-timepicker-toggle>
                                        <ngx-mat-timepicker
                                            #timePicker
                                            appendToInput="true"
                                        ></ngx-mat-timepicker>
                                        <mat-error
                                            >{{ field.name | translate }}
                                            {{ "is required" | translate }}</mat-error
                                        >
                                        @if (timeError && entity[field.property]) {
                                            <span>
                                                <mat-error>{{ timeError }}</mat-error>
                                            </span>
                                        }
                                    </mat-form-field>
                                }

                                @if (field.type === FormFieldType.Date && field.visible) {
                                    <div
                                        class="container"
                                        [ngClass]="field.cssClass">
                                        <mat-form-field class="row">
                                            <mat-label class="field-label">
                                                {{ field.name | translate }}
                                                @if (field.tooltip) {
                                                    <i
                                                        class="fa fa-info-circle"
                                                        aria-hidden="true"
                                                        [matTooltip]="field.tooltip"
                                                        matTooltipPosition="right"
                                                    ></i>
                                                }
                                            </mat-label>
                                            <input
                                                matInput
                                                [required]="field.required"
                                                [readonly]="field.readonly"
                                                [class]="field.cssClass"
                                                [(ngModel)]="entity[field.property]"
                                                [min]="$safeNavigationMigration(field?.min)"
                                                [max]="$safeNavigationMigration(field?.max)"
                                                [value]="entity[field.property]"
                                                [matDatepicker]="picker"
                                                [placeholder]="field.tooltip"
                                                [disabled]="field.readonly"
                                                (ngModelChange)="
                                                    field.onChange($event, field); updateFieldVisibility()
                                                "
                                            />
                                            <mat-datepicker-toggle
                                                matIconSuffix
                                                [for]="picker"
                                            ></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                            <mat-error
                                                >{{ field.name | translate }}
                                                {{
                                                    "is required" | translate
                                                }}</mat-error
                                            >
                                        </mat-form-field>
                                    </div>
                                }

                                @if (field.type === FormFieldType.DateTime && field.visible) {
                                    <div
                                        class="container"
                                        [ngClass]="field.cssClass">
                                        <mat-form-field class="row">
                                            <mat-label class="field-label">
                                                {{ field.name | translate }}
                                                @if (field.tooltip) {
                                                    <i
                                                        class="fa fa-info-circle"
                                                        aria-hidden="true"
                                                        [matTooltip]="field.tooltip"
                                                        matTooltipPosition="right"
                                                    ></i>
                                                }
                                            </mat-label>
                                            <input
                                                matInput
                                                [required]="field.required"
                                                [class]="field.cssClass"
                                                [(ngModel)]="entity[field.property]"
                                                [min]="$safeNavigationMigration(field?.min)"
                                                [max]="$safeNavigationMigration(field?.max)"
                                                [owlDateTimeTrigger]="dtPicker"
                                                [owlDateTime]="dtPicker"
                                                [placeholder]="field.tooltip"
                                                [disabled]="field.readonly"
                                                (ngModelChange)="
                                                    field.onChange($event, field); updateFieldVisibility()
                                                "
                                            />
                                            <owl-date-time
                                                #dtPicker
                                                [panelClass]="'form-owl-date-picker'"
                                                [hour12Timer]="('' | hour12Flag) === 12"
                                            >
                                            </owl-date-time>
                                            <mat-error
                                                >{{ field.name | translate }}
                                                {{
                                                    "is required" | translate
                                                }}</mat-error
                                            >
                                        </mat-form-field>
                                    </div>
                                }

                                @if (field.type === FormFieldType.FileAttachments && field.visible) {
                                    <div
                                        class="container"
                                        [ngClass]="field.cssClass">
                                        <div class="row">
                                            <a
                                                class="add-attachment"
                                                (click)="field.onClick(0)"
                                                >{{ field.additionalLabelText }}
                                            </a>
                                            @for (attachment of field.options; track trackByEntityId($index, attachment)) {
                                                <div
                                                    class="attachment-item"
                                                >
                                                    <span
                                                        >{{ attachment.name }}
                                                        {{ attachment.description }}</span
                                                    >
                                                    <button
                                                        mat-icon-button
                                                        color="warn"
                                                        (click)="
                                                            field.onClick(attachment.id)
                                                        "
                                                    >
                                                        <mat-icon>close</mat-icon>
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }

                                @if (field.type === FormFieldType.Array && field.visible) {
                                    <div
                                        [class]="field.cssClass"
                                    >
                                        @for (item of field.items; track $index; let i = $index) {
                                            <div
                                                class="array-row"
                                            >
                                                @for (fieldItem of item; track $index; let j = $index) {
                                                    <div
                                                        [class]="fieldItem.itemCssClass"
                                                    >
                                                        @if (
                                                                fieldItem.type ===
                                                                    FormFieldType.Button &&
                                                                fieldItem.rowVisibility?.[i]
                                                        ) {
                                                            <div
                                                                [ngClass]="fieldItem.cssClass"
                                                                [class.disabled-div]="
                                                                    fieldItem.readonly
                                                                "
                                                            >
                                                                <button
                                                                    mat-button
                                                                    (click)="
                                                                        fieldItem.onClick(
                                                                            entity[field.property][
                                                                                i
                                                                            ]
                                                                        )
                                                                    "
                                                                    class="button"
                                                                    [disabled]="fieldItem.readonly"
                                                                >
                                                                    @if (fieldItem.iconClass) {
                                                                        <span>
                                                                            <i
                                                                                [ngClass]="
                                                                                    fieldItem.iconClass
                                                                                "
                                                                                class="icon"
                                                                            ></i>
                                                                        </span>
                                                                    }
                                                                    {{ fieldItem.name | translate }}
                                                                </button>
                                                            </div>
                                                        }

                                                        <div>
                                                            @if (
                                                                    fieldItem.type ===
                                                                        FormFieldType.Text &&
                                                                    fieldItem.rowVisibility?.[i]
                                                            ) {
                                                                <mat-form-field
                                                                    class="row"
                                                                    [class]="field.cssClass"
                                                                >
                                                                    <mat-label class="field-label">
                                                                        {{
                                                                            fieldItem.name
                                                                                | translate
                                                                        }}
                                                                        @if (fieldItem.tooltip) {
                                                                            <i
                                                                                class="fa fa-info-circle"
                                                                                aria-hidden="true"
                                                                                [matTooltip]="
                                                                                    fieldItem.tooltip
                                                                                "
                                                                                matTooltipPosition="right"
                                                                            ></i>
                                                                        }
                                                                    </mat-label>
                                                                    <input
                                                                        matInput
                                                                        type="text"
                                                                        [(ngModel)]="
                                                                            entity[field.property][
                                                                                i
                                                                            ][fieldItem.property]
                                                                        "
                                                                        [readonly]="fieldItem.readonly"
                                                                        [placeholder]="
                                                                            fieldItem.tooltip
                                                                        "
                                                                        [required]="
                                                                            fieldItem.isRequired
                                                                        "
                                                                        [class.cursor-not-allowed]="
                                                                            fieldItem.readonly
                                                                        "
                                                                    />
                                                                    @if (fieldItem.isRequired) {
                                                                        <mat-error>
                                                                            {{
                                                                                fieldItem.name
                                                                                    | translate
                                                                            }}
                                                                            {{
                                                                                "is required"
                                                                                    | translate
                                                                            }}</mat-error
                                                                        >
                                                                    }
                                                                </mat-form-field>
                                                            }
                                                        </div>

                                                        @if (fieldItem.type === FormFieldType.Toggle && fieldItem.visible) {
                                                            <div
                                                                [class]="fieldItem.cssClass"
                                                            >
                                                                <mat-label class="field-label mr-3">
                                                                    {{ fieldItem.name | translate }}
                                                                    @if (fieldItem.tooltip) {
                                                                        <i
                                                                            class="fa fa-info-circle"
                                                                            aria-hidden="true"
                                                                            [matTooltip]="
                                                                                fieldItem.tooltip
                                                                            "
                                                                            matTooltipPosition="right"
                                                                        ></i>
                                                                    }
                                                                </mat-label>
                                                                <mat-slide-toggle
                                                                    color="primary"
                                                                    [disabled]="fieldItem.readonly"
                                                                    (change)="
                                                                        fieldItem.onChange(
                                                                            $event,
                                                                            field,
                                                                            i
                                                                        ); updateFieldVisibility()
                                                                    "
                                                                    [(ngModel)]="
                                                                        entity[field.property][i][
                                                                            fieldItem.property
                                                                        ]
                                                                    "
                                                                ></mat-slide-toggle>
                                                            </div>
                                                        }

                                                        @if (fieldItem.type === FormFieldType.Label && fieldItem.visible) {
                                                            <div
                                                                [class]="fieldItem.cssClass"
                                                                (click)="
                                                                    fieldItem.onClick(
                                                                        entity[field.property][i][
                                                                            fieldItem.property
                                                                        ]
                                                                    )
                                                                "
                                                            >
                                                                @if (fieldItem.iconClass) {
                                                                    <span>
                                                                        <i
                                                                            [ngClass]="
                                                                                fieldItem.iconClass
                                                                            "
                                                                            class="icon"
                                                                        ></i>
                                                                    </span>
                                                                }
                                                                <mat-label class="field-label mr-3">
                                                                    {{ fieldItem.name | translate }}
                                                                    @if (fieldItem.tooltip) {
                                                                        <i
                                                                            class="fa fa-info-circle"
                                                                            aria-hidden="true"
                                                                            [matTooltip]="
                                                                                fieldItem.tooltip
                                                                            "
                                                                            matTooltipPosition="right"
                                                                        ></i>
                                                                    }
                                                                </mat-label>
                                                            </div>
                                                        }

                                                        @if (
                                                                fieldItem.type ===
                                                                    FormFieldType.Number &&
                                                                fieldItem.rowVisibility?.[i]
                                                        ) {
                                                            <div
                                                                [class.disabled-div]="
                                                                    fieldItem.readonly
                                                                "
                                                            >
                                                                <mat-form-field>
                                                                    <mat-label class="field-label">
                                                                        {{
                                                                            fieldItem.name
                                                                                | translate
                                                                        }}
                                                                        {{
                                                                            fieldItem.additionalLabelText
                                                                        }}
                                                                        @if (fieldItem.tooltip) {
                                                                            <i
                                                                                class="fa fa-info-circle"
                                                                                aria-hidden="true"
                                                                                [matTooltip]="
                                                                                    fieldItem.tooltip
                                                                                "
                                                                                matTooltipPosition="right"
                                                                            ></i>
                                                                        }
                                                                    </mat-label>
                                                                    <input
                                                                        matInput
                                                                        type="number"
                                                                        [min]="fieldItem.numericMin"
                                                                        [readonly]="
                                                                            fieldItem.readonly
                                                                        "
                                                                        [class.cursor-not-allowed]="
                                                                            fieldItem.readonly
                                                                        "
                                                                        [required]="
                                                                            fieldItem.isRequired
                                                                        "
                                                                        [readonly]="
                                                                            fieldItem.readonly
                                                                        "
                                                                        (input)="
                                                                            fieldItem.onChange(
                                                                                $event,
                                                                                field,
                                                                                i
                                                                            ); updateFieldVisibility()
                                                                        "
                                                                        [max]="fieldItem.numericMax"
                                                                        [(ngModel)]="
                                                                            entity[field.property][
                                                                                i
                                                                            ][fieldItem.property]
                                                                        "
                                                                        (keypress)="
                                                                            onKeyPressValidateInput(
                                                                                $event,
                                                                                fieldItem.displayFormat,
                                                                                fieldItem.numericMin
                                                                            )
                                                                        "
                                                                        [placeholder]="
                                                                            fieldItem.tooltip
                                                                        "
                                                                    />
                                                                </mat-form-field>
                                                            </div>
                                                        }

                                                        @if (
                                                                fieldItem.type ===
                                                                    FormFieldType.Time &&
                                                                fieldItem.rowVisibility?.[i]
                                                        ) {
                                                            <div
                                                                [class]="fieldItem.cssClass"
                                                            >
                                                                <mat-form-field class="row">
                                                                    <mat-label class="field-label">
                                                                        {{
                                                                            fieldItem.name
                                                                                | translate
                                                                        }}
                                                                        @if (fieldItem.tooltip) {
                                                                            <i
                                                                                class="fa fa-info-circle"
                                                                                aria-hidden="true"
                                                                                [matTooltip]="
                                                                                    fieldItem.tooltip
                                                                                "
                                                                                matTooltipPosition="right"
                                                                            ></i>
                                                                        }
                                                                    </mat-label>
                                                                    <input
                                                                        matInput
                                                                        [required]="
                                                                            fieldItem.isRequired
                                                                        "
                                                                        class="time-input"
                                                                        [disabled]="
                                                                            fieldItem.readonly
                                                                        "
                                                                        [(ngModel)]="
                                                                            entity[field.property][
                                                                                i
                                                                            ][fieldItem.property]
                                                                        "
                                                                        (ngModelChange)="
                                                                            onTimeChange(
                                                                                $event,
                                                                                field,
                                                                                fieldItem,
                                                                                i
                                                                            )
                                                                        "
                                                                        [ngxMatTimepicker]="
                                                                            timePicker
                                                                        "
                                                                        [format]="'' | hour12Flag"
                                                                        [readonly]="field.readonly"
                                                                        [placeholder]="
                                                                            fieldItem.tooltip
                                                                        "
                                                                    />
                                                                    <ngx-mat-timepicker-toggle
                                                                        matSuffix
                                                                        [for]="timePicker"
                                                                    ></ngx-mat-timepicker-toggle>
                                                                    <ngx-mat-timepicker
                                                                        #timePicker
                                                                        appendToInput="true"
                                                                    ></ngx-mat-timepicker>
                                                                </mat-form-field>
                                                                @if (timeError && entity[field.property][i][fieldItem.property]) {
                                                                    <span>
                                                                        <mat-error>{{
                                                                            timeError
                                                                        }}</mat-error>
                                                                    </span>
                                                                }
                                                            </div>
                                                        }

                                                        @if (fieldItem.type === FormFieldType.Date && fieldItem.visible) {
                                                            <div
                                                                class="container"
                                                                [class]="fieldItem.cssClass"
                                                            >
                                                                <mat-form-field class="row">
                                                                    <mat-label class="field-label">
                                                                        {{
                                                                            fieldItem.name
                                                                                | translate
                                                                        }}
                                                                        @if (fieldItem.tooltip) {
                                                                            <i
                                                                                class="fa fa-info-circle"
                                                                                aria-hidden="true"
                                                                                [matTooltip]="
                                                                                    fieldItem.tooltip
                                                                                "
                                                                                matTooltipPosition="right"
                                                                            ></i>
                                                                        }
                                                                    </mat-label>
                                                                    <input
                                                                        matInput
                                                                        [required]="
                                                                            fieldItem.isRequired
                                                                        "
                                                                        [readonly]="field.readonly"
                                                                        [placeholder]="
                                                                            fieldItem.tooltip
                                                                        "
                                                                        [(ngModel)]="
                                                                            entity[field.property][
                                                                                i
                                                                            ][fieldItem?.property]
                                                                        "
                                                                        [min]="$safeNavigationMigration(fieldItem?.min)"
                                                                        [max]="$safeNavigationMigration(fieldItem?.max)"
                                                                        [value]="
                                                                            entity &&
                                                                            entity[
                                                                                field.property
                                                                            ] &&
                                                                            entity[field.property][
                                                                                i
                                                                            ] &&
                                                                            entity[field.property][
                                                                                i
                                                                            ][fieldItem?.property]
                                                                        "
                                                                        [matDatepicker]="picker"
                                                                        [disabled]="field.readonly"
                                                                        (ngModelChange)="
                                                                            fieldItem.onChange(
                                                                                $event,
                                                                                field,
                                                                                i
                                                                            ); updateFieldVisibility()
                                                                        "
                                                                    />
                                                                    <mat-datepicker-toggle
                                                                        matIconSuffix
                                                                        [for]="picker"
                                                                    ></mat-datepicker-toggle>
                                                                    <mat-datepicker
                                                                        #picker
                                                                    ></mat-datepicker>
                                                                    @if (fieldItem.isRequired) {
                                                                        <mat-error>
                                                                            {{
                                                                                $safeNavigationMigration(fieldItem?.name)
                                                                                    | translate
                                                                            }}
                                                                            {{
                                                                                "is required"
                                                                                    | translate
                                                                            }}</mat-error
                                                                        >
                                                                    }
                                                                </mat-form-field>
                                                            </div>
                                                        }

                                                        @if (fieldItem.type === FormFieldType.DateTime && fieldItem.visible) {
                                                            <div
                                                                class="container"
                                                                [class]="fieldItem.cssClass"
                                                            >
                                                                <mat-form-field class="row">
                                                                    <mat-label class="field-label">
                                                                        {{
                                                                            fieldItem.name
                                                                                | translate
                                                                        }}
                                                                        @if (fieldItem.tooltip) {
                                                                            <i
                                                                                class="fa fa-info-circle"
                                                                                aria-hidden="true"
                                                                                [matTooltip]="
                                                                                    fieldItem.tooltip
                                                                                "
                                                                                matTooltipPosition="right"
                                                                            ></i>
                                                                        }
                                                                    </mat-label>
                                                                    <input
                                                                        matInput
                                                                        [required]="
                                                                            fieldItem.isRequired
                                                                        "
                                                                        [(ngModel)]="
                                                                            entity[field.property][
                                                                                i
                                                                            ][fieldItem?.property]
                                                                        "
                                                                        [min]="$safeNavigationMigration(fieldItem?.min)"
                                                                        [max]="$safeNavigationMigration(fieldItem?.max)"
                                                                        [owlDateTimeTrigger]="
                                                                            dtPicker
                                                                        "
                                                                        [owlDateTime]="dtPicker"
                                                                        [disabled]="field.readonly"
                                                                        [placeholder]="
                                                                            fieldItem.tooltip
                                                                        "
                                                                        (ngModelChange)="
                                                                            fieldItem.onChange(
                                                                                $event,
                                                                                field,
                                                                                i
                                                                            ); updateFieldVisibility()
                                                                        "
                                                                    />
                                                                    <owl-date-time
                                                                        #dtPicker
                                                                        [panelClass]="'form-owl-date-picker'"
                                                                        [hour12Timer]="
                                                                            ('' | hour12Flag) === 12
                                                                        "
                                                                    >
                                                                    </owl-date-time>
                                                                    @if (fieldItem.isRequired) {
                                                                        <mat-error
                                                                            >{{
                                                                                $safeNavigationMigration(fieldItem?.name)
                                                                                    | translate
                                                                            }}
                                                                            {{
                                                                                "is required"
                                                                                    | translate
                                                                            }}</mat-error
                                                                        >
                                                                    }
                                                                </mat-form-field>
                                                            </div>
                                                        }

                                                        @if (
                                                                (fieldItem.type ===
                                                                    FormFieldType.SingleSelection ||
                                                                    fieldItem.type ===
                                                                        FormFieldType.MultipleSelection) &&
                                                                fieldItem.visible
                                                        ) {
                                                            <div
                                                                [class]="fieldItem.cssClass"
                                                            >
                                                                <mat-form-field>
                                                                    <mat-label class="field-label">
                                                                        {{
                                                                            fieldItem.name
                                                                                | translate
                                                                        }}
                                                                        @if (fieldItem.tooltip) {
                                                                            <i
                                                                                class="fa fa-info-circle"
                                                                                aria-hidden="true"
                                                                                [matTooltip]="
                                                                                    fieldItem.tooltip
                                                                                "
                                                                                matTooltipPosition="right"
                                                                            ></i>
                                                                        }
                                                                    </mat-label>
                                                                    <mat-select
                                                                        (selectionChange)="
                                                                            fieldItem.onChange(
                                                                                $event,
                                                                                fieldItem
                                                                            ); updateFieldVisibility()
                                                                        "
                                                                        [(ngModel)]="
                                                                            entity[field.property][
                                                                                i
                                                                            ][fieldItem.property]
                                                                        "
                                                                        [required]="
                                                                            fieldItem.isRequired
                                                                        "
                                                                        [disabled]="
                                                                            $safeNavigationMigration(fieldItem?.readonly)
                                                                        "
                                                                        [placeholder]="
                                                                            fieldItem.tooltip
                                                                        "
                                                                        [class.cursor-not-allowed]="
                                                                            fieldItem.readonly
                                                                        "
                                                                        [multiple]="
                                                                            fieldItem.type ===
                                                                            FormFieldType.MultipleSelection
                                                                        "
                                                                    >
                                                                        <mat-option>
                                                                            <ngx-mat-select-search
                                                                                [(ngModel)]="
                                                                                    entity[
                                                                                        field
                                                                                            .property
                                                                                    ][i][
                                                                                        fieldItem
                                                                                            .searchProperty
                                                                                    ]
                                                                                "
                                                                                placeholderLabel="{{
                                                                                    'Search'
                                                                                        | translate
                                                                                }}..."
                                                                            ></ngx-mat-select-search>
                                                                        </mat-option>

                                                                        @if (fieldItem.groups && fieldItem.groups.length > 0) {
                                                                            @for (group of fieldItem.groups; track $index) {
                                                                                <mat-optgroup
                                                                                    [label]="
                                                                                        group.groupName
                                                                                    "
                                                                                >
                                                                                    @for (option of group.items | filter : entity[field.property][i][fieldItem.searchProperty]; track trackByEntityId($index, option)) {
                                                                                        <mat-option
                                                                                            [value]="
                                                                                                option.id
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                option.name
                                                                                                    | translate
                                                                                            }}
                                                                                        </mat-option>
                                                                                    }
                                                                                    @if (
                                                                                            (
                                                                                                group.items
                                                                                                | filter
                                                                                                    : entity[
                                                                                                          field
                                                                                                              .property
                                                                                                      ][
                                                                                                          i
                                                                                                      ][
                                                                                                          fieldItem
                                                                                                              .searchProperty
                                                                                                      ]
                                                                                            ).length ===
                                                                                            0
                                                                                    ) {
                                                                                        <mat-option
                                                                                            disabled
                                                                                        >
                                                                                            {{
                                                                                                "No options found"
                                                                                                    | translate
                                                                                            }}
                                                                                        </mat-option>
                                                                                    }
                                                                                </mat-optgroup>
                                                                            }
                                                                        } @else {
                                                                            @for (option of fieldItem.options | filter : entity[field.property][i][fieldItem.searchProperty]; track trackByEntityId($index, option)) {
                                                                                <mat-option
                                                                                    [value]="option.id"
                                                                                >
                                                                                    {{
                                                                                        option.name
                                                                                            | translate
                                                                                    }}
                                                                                </mat-option>
                                                                            }
                                                                            @if (
                                                                                    (
                                                                                        fieldItem.options
                                                                                        | filter
                                                                                            : entity[
                                                                                                  field
                                                                                                      .property
                                                                                              ][i][
                                                                                                  fieldItem
                                                                                                      .searchProperty
                                                                                              ]
                                                                                    ).length === 0
                                                                            ) {
                                                                                <mat-option
                                                                                    disabled
                                                                                >
                                                                                    {{
                                                                                        "No options found"
                                                                                            | translate
                                                                                    }}
                                                                                </mat-option>
                                                                            }
                                                                        }

                                                                    </mat-select>
                                                                    @if (
                                                                            entity[field.property][
                                                                                i
                                                                            ][
                                                                                fieldItem.property
                                                                            ] !== null &&
                                                                            entity[field.property][
                                                                                i
                                                                            ][
                                                                                fieldItem.property
                                                                            ] !== undefined &&
                                                                            fieldItem.type ===
                                                                                FormFieldType.SingleSelection &&
                                                                            !fieldItem?.readonly
                                                                    ) {
                                                                        <button
                                                                            class="selection-close-btn"
                                                                            mat-icon-button
                                                                            matSuffix
                                                                            tabindex="-1"
                                                                            (click)="
                                                                                clearArraySelect(
                                                                                    field,
                                                                                    fieldItem,
                                                                                    i
                                                                                );
                                                                                $event.stopPropagation()
                                                                            "
                                                                            [attr.aria-label]="
                                                                                'Clear selection'
                                                                                    | translate
                                                                            "
                                                                        >
                                                                            <mat-icon>close</mat-icon>
                                                                        </button>
                                                                    }
                                                                    @if (fieldItem.isRequired) {
                                                                        <mat-error
                                                                            >{{
                                                                                fieldItem.name
                                                                                    | translate
                                                                            }}
                                                                            {{
                                                                                "is required"
                                                                                    | translate
                                                                            }}</mat-error
                                                                        >
                                                                    }
                                                                </mat-form-field>
                                                            </div>
                                                        }

                                                        @if (fieldItem.type === FormFieldType.Checkbox && fieldItem.visible) {
                                                            <div
                                                                class="padding-y-10">
                                                                <mat-checkbox
                                                                    color="primary"
                                                                    [(ngModel)]="
                                                                        entity[field.property][i][
                                                                            fieldItem.property
                                                                        ]
                                                                    "
                                                                    (change)="
                                                                        fieldItem.onChange($event); updateFieldVisibility()
                                                                    "
                                                                >
                                                                    {{ fieldItem.name | translate }}
                                                                </mat-checkbox>
                                                            </div>
                                                        }

                                                        @if (fieldItem.type === FormFieldType.Radio && fieldItem.visible) {
                                                            <div
                                                                class="padding-y-10"
                                                                [class]="fieldItem.cssClass"
                                                            >
                                                                <label
                                                                    class="field-label block mb-2"
                                                                    >{{
                                                                        fieldItem.name | translate
                                                                    }}
                                                                    @if (fieldItem.tooltip) {
                                                                        <i
                                                                            class="fa fa-info-circle"
                                                                            aria-hidden="true"
                                                                            [matTooltip]="
                                                                                fieldItem.tooltip
                                                                            "
                                                                            matTooltipPosition="right"
                                                                        ></i>
                                                                    }
                                                                </label>
                                                                <mat-radio-group
                                                                    [(ngModel)]="
                                                                        entity[field.property][i][
                                                                            fieldItem.property
                                                                        ]
                                                                    "
                                                                >
                                                                    @for (option of fieldItem.options; track trackByEntityId($index, option)) {
                                                                        <mat-radio-button
                                                                            [value]="option.id"
                                                                            (change)="
                                                                                fieldItem.onChange(
                                                                                    option.id,
                                                                                    field,
                                                                                    i
                                                                                ); updateFieldVisibility()
                                                                            "
                                                                        >
                                                                            {{
                                                                                option.name | translate
                                                                            }}
                                                                        </mat-radio-button>
                                                                    }
                                                                </mat-radio-group>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
                <div mat-dialog-actions class="createButton mt-2">
                    @if (!isReadonly) {
                        <button
                            class="btn modal-footer-btn save-modal-btn"
                            (click)="mainButtonClick()"
                            [class.cursor-not-allowed]="isLoading"
                            [disabled]="cachedDisabled"
                        >
                            {{ mainButtonText }}
                        </button>
                    }

                    <div class="createButton mt-3">
                        <button
                            class="btn modal-footer-btn cancel-modal-btn"
                            (click)="close()"
                        >
                            {{ closeButtonText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
